<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h3 class="text-uppercase" *ngIf="subjectBecomeSeller != '/become-seller' && subjectBecomeSeller != '/about-us'">{{'IDS_NEED_HELP' | translate}}</h3>
        <h3 class="text-uppercase" *ngIf="subjectBecomeSeller == '/become-seller'">{{'IDS_BECOME_SELLER' | translate}}</h3>
        <h3 class="text-uppercase" *ngIf="subjectBecomeSeller == '/about-us'">{{'IDS_CONTACT_ABOUT_US_CONTACT_MEMORABID' | translate}}</h3>
    </div>
    <div class="mt-3">
        <form (ngSubmit)="contact(contactForm)" #contactForm="ngForm">
            <div class="d-flex flex-column">
                <label
                    class="fw-bold pb-2 email-subject-label"
                    for="subject">
                    {{'IDS_MESSAGE_SUBJECT' | translate}}
                </label>
                <select id="subject" class="email-subject" [class.preEvent]="inPreEventStatus" name="subject" [(ngModel)]="subject" required *ngIf="subjectBecomeSeller != '/become-seller' && subjectBecomeSeller != '/about-us'">
                    <option
                        *ngFor="let subject of emailSubjects;"
                        [value]="subject.ids">
                        {{ subject.ids | translate }}
                    </option>
                </select>
                <select class="email-subject" name="subject" [(ngModel)]="subject" required *ngIf="subjectBecomeSeller == '/become-seller'">
                    <option value="IDS_WANT_BECOME_SELLER_SUBJECT" [selected]="true">
                        {{ 'IDS_WANT_BECOME_SELLER_SUBJECT' | translate }}
                    </option>
                </select>
                <select class="email-subject" name="subject" [(ngModel)]="subject" required *ngIf="subjectBecomeSeller == '/about-us'">
                    <option value="IDS_CONTACT_ABOUT_US_GENERIC_REQUEST" [selected]="true">
                        {{ 'IDS_CONTACT_ABOUT_US_GENERIC_REQUEST' | translate }}
                    </option>
                </select>
            </div>
            <div class="d-flex flex-column mt-2" *ngIf="!authService.isAuthenticated()">
                <label
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_FIRSTNAME' | translate}}
                </label>
                <input
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="firstname"
                    class="form-control"
                    [(ngModel)]="firstName"
                    name="firstname"
                    required>
            </div>
            <div class="d-flex flex-column mt-2" *ngIf="!authService.isAuthenticated()">
                <label
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_LASTNAME' | translate}}
                </label>
                <input
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="lastname"
                    class="form-control"
                    [(ngModel)]="lastName"
                    name="lastname"
                    required>
            </div>
            <div class="d-flex flex-column mt-2" *ngIf="!authService.isAuthenticated()">
                <label
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_EMAIL' | translate}}
                </label>
                <input
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="email"
                    id="email"
                    class="form-control"
                    [(ngModel)]="email"
                    name="email"
                    required>
                <div class="error-label mb-2" *ngIf="isEmailInvalid">
                    <label>{{'IDS_EMAIL_NOT_VALID' | translate }}</label>
                </div>
            </div>
            <div class="d-flex flex-column mt-2" *ngIf="!authService.isAuthenticated()">
                <label
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_PHONE' | translate}}
                </label>
                <input
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="phone"
                    class="form-control"
                    [(ngModel)]="phone"
                    name="phone"
                    required>
            </div>
            <div class="d-flex flex-column mt-2">
                <label
                    *ngIf="subjectBecomeSeller != '/become-seller'"
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_REQUEST' | translate}}
                </label>
                <label
                    *ngIf="subjectBecomeSeller == '/become-seller'"
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_WANT_BECOME_SELLER_REQUEST' | translate}}
                </label>
                <textarea
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="message"
                    class="form-control"
                    ngModel
                    name="message"
                    required>
                </textarea>
            </div>
            <div class="d-flex flex-column mt-2"  *ngIf="subjectBecomeSeller == '/become-seller'">
                <label
                    *ngIf="subjectBecomeSeller == '/become-seller'"
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_WANT_BECOME_SELLER_MOREINFO' | translate}}
                </label>
                <textarea
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="moreinfo"
                    class="form-control"
                    ngModel
                    name="moreinfo"
                    required>
                </textarea>
            </div>
            <label class="text-muted label-container text-privacy">
                <input class="input-checkbox" type="checkbox" checked="checked" name="subscribe" [(ngModel)]="acceptPolicy">
                    {{"IDS_ACCEPT" | translate}}
                    <a [class.privacy-policy-gold]="isMemorabid && !inPreEventStatus" [class.privacy-policy-marketplace]="isMemorabid && !inPreEventStatus" [class.privacy-policy-preEvent]="inPreEventStatus" (click)="goToPage('privacy-policy')">Privacy Policy</a>
                <span class="checkmark"></span>
            </label>
            <div *ngIf="policyNotAccepted">
                <label class="error-label">{{ 'IDS_FIELD_REQUIRED' | translate }}</label>
            </div>
            <div class="d-flex justify-content-center mt-2">
                <button
                    *ngIf="subjectBecomeSeller != '/become-seller'"
                    type="submit"
                    [class.btn-gold]="isMemorabid && !inPreEventStatus"
                    [class.btn-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.btn-preEvent]="inPreEventStatus"
                    class="btn-dialog text-uppercase fw-bold px-3"
                    [disabled] = "!contactForm.valid">
                    {{'IDS_NEED_HELP_SEND' | translate}}
                </button>
                <button
                    *ngIf="subjectBecomeSeller == '/become-seller'"
                    type="submit"
                    [class.btn-gold]="isMemorabid && !inPreEventStatus"
                    [class.btn-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.btn-preEvent]="inPreEventStatus"
                    class="btn-dialog text-uppercase fw-bold px-3"
                    [disabled] = "!contactForm.valid">
                    {{'IDS_WANT_BECOME_SELLER_SEND_REQUEST' | translate}}
                </button>
            </div>
            <div class="d-flex justify-content-center my-3">
                <button class="admin-new text-uppercase fw-bold px-3" [class.preEvent]="inPreEventStatus" type="button" (click)="activeModal.close()">
                    {{'IDS_BTN_ABORT' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>
